export default __webpack_public_path__ + "static/joko-app-screenshot-home-1-fr-86d3f65ef5097b41b60be313d4534838.webp";